export const isSSR = !(
  typeof window !== 'undefined' && window.document?.createElement
)

export const isInStandaloneMode =
  typeof window !== 'undefined' &&
  (('standalone' in window.navigator && window.navigator.standalone) ||
    window.matchMedia('(display-mode: standalone)').matches)
